import React from 'react';
import PropTypes from 'prop-types';

import MuiPopper from '@material-ui/core/Popper';
import { useTheme } from '@material-ui/core/styles';

function Popper({
  style,
  ...rest
}) {
  const theme = useTheme();

  return (
    <MuiPopper
      style={{
        zIndex: theme.zIndex.modal,
        ...style,
      }}
      {...rest}
    />
  );
}

Popper.defaultProps = {
  style: {},
};

Popper.propTypes = {
  style: PropTypes.object,
};

export default Popper;
